import { Row, Col } from "../../components/Layout";
import React, { useState, useRef } from "react";
import { parseISO } from 'date-fns';
import { DatePickerWithHighlights } from "../../load-build/formControl/DatePickerWithHighlights";
import _ from 'lodash';
import dayjs from "dayjs";

export const TruckFormElements = (props) => {
  const {
    avisDate,
    avisDateError,
    avisDateErrorMessage,
    estimatedArrivalDate,
    estimatedArrivalDateError,
    estimatedArrivalDateErrorMessage,
    truckPlate,
    truckplateError,
    trailorPlate,
    trailorplateError,
    driverName,
    driverNameError,
    handleTruckPlateChange,
    highlightedDates,
  } = props;
  
  const dateArray = highlightedDates ? highlightedDates.split(',').map(date => new Date(date.trim())) : [];
  let currentDate = new Date();
  currentDate.setHours(0, 0, 0, 0);
  let filteredDates = dateArray.filter(date => {
    date.setHours(0, 0, 0, 0);
    return date >= currentDate;
  });

  const [avisdateState, setAvisdateState] = useState(null);
  const [estimatedArrivalDateState, setEstimatedArrivalDateState] = useState(null);

  const datePickerRef = useRef(null);

  return (
    <Col className="pl-[5%] text-base">
      <Row className="min-w-80">
        <label id="avis-form-pld-label" className="text-xs pr-[2%]">Planned Loading Date :</label>
        <DatePickerWithHighlights
          name="avisdate"
          enableTime="true"
          ref={datePickerRef}
          value={_.isNull(avisdateState) && !_.isEmpty(avisDate) ? parseISO(avisDate) : avisdateState}
          onChange={(date) => {
            setAvisdateState(date[0]);
          }}
          max={new Date(new Date().setMonth(new Date().getMonth() + 3))}
          placeholder="Select Date and Time"
          highlightedDates={filteredDates}
        />

        {avisDateError && (
          <p id="avis-form-pld-err" className="text-xs text-red-500 ml-[40%] mb-[-5%]">
            {avisDateErrorMessage}
          </p>
        )}
      </Row>
      <br />
      <Row>
        <label className="text-xs pr-[2%]">Estimated Arrival Date :</label>
        <DatePickerWithHighlights
          name="estimatedArrivalDate"
          enableTime="false"
          ref={datePickerRef}
          value={_.isNull(estimatedArrivalDateState) && !_.isEmpty(estimatedArrivalDate) ? parseISO(estimatedArrivalDate) : estimatedArrivalDateState}
          onChange={(date) => {
            setEstimatedArrivalDateState(date[0]);
          }}
          min={new Date()}
          placeholder="Select Date"
        />
        {estimatedArrivalDateError && (
          <p id="avis-form-ead-err" className="text-xs text-red-500 ml-[40%] mb-[-5%]">
            {estimatedArrivalDateErrorMessage}
          </p>
        )}
      </Row>
      <br />
      <Row className="items-center">
        <label id="avis-form-tp-label" className="text-xs pr-[5%]">Truck Plate : </label>
        <input
          id="avis-form-tp-input"
          className="text-xs ml-[6%] pr-[5.5%] border-[1px] border-gray-500 rounded-sm p-[3px]"
          name="truckplate"
          defaultValue={truckPlate}
          onChange={handleTruckPlateChange}
          type="text"
        ></input>
        {truckplateError && (
          <p id="avis-form-tp-err" className="text-xs text-red-500 ml-[40%] mb-[-5%]">
            Truck plate is invalid
          </p>
        )}
      </Row>
      <br />
      <Row className="items-center">
        <label id="avis-form-trp-label" className="text-xs pr-[3.5%]">Trailer Plate :</label>
        <input
          id="avis-form-trp-input"
          className="text-xs ml-[6%] pr-[5.5%] border-[1px] border-gray-500 rounded-sm p-[3px]"
          name="trailorplate"
          defaultValue={trailorPlate}
          type="text"
        ></input>
        {trailorplateError && (
          <p id="avis-form-trp-err" className="text-xs text-red-500 ml-[40%] mb-[-5%]">
            Trailer plate is invalid
          </p>
        )}
      </Row>
      <br />
      <Row className="items-center">
        <label id="avis-form-dn-label" className="text-xs pr-[2%]">Driver Name :</label>
        <input
          id="avis-form-dn-input"
          className="text-xs ml-[6%] pr-[5.5%] border-[1px] border-gray-500 rounded-sm p-[3px]"
          name="driverName"
          defaultValue={driverName}
          type="text"
        ></input>
        {driverNameError && (
          <p id="avis-form-dn-err" className="text-xs text-red-500 ml-[40%] mb-[-5%]">
            Driver name is invalid
          </p>
        )}
      </Row>
    </Col>
  );
};